import { createContext } from "react";

const EnrichmentsContext = createContext({
  Enrichments_refetchEnrichmentFlows: () => {},
} as {
  Enrichments_refetchEnrichmentFlows: () => Promise<any>;
});

export default EnrichmentsContext;
